import * as React from 'react';
import { useAuth } from 'react-oidc-context';

import { useLocation } from 'react-router';
import { useConfig } from '~/common/context';
import { Matomo } from '~/common/helpers';

export function MatomoTrackingProvider(props: React.PropsWithChildren) {
  const location = useLocation();
  const auth = useAuth();
  const config = useConfig();

  React.useEffect(() => {
    if (!window._paq) {
      return;
    }

    window._paq.push(['setCustomUrl', location.pathname]);
    window._paq.push(['setUserId', auth.user?.profile.sub ?? 'guest']);

    // Result pages call trackSiteSearch instead — skip trackPageView
    // to avoid double-counting (Matomo recommendation).
    if (!Matomo.consumeSuppressPageView()) {
      window._paq.push(['trackPageView']);
    }
  }, [auth.user?.profile.sub, config.tenantCode, location.pathname]);

  return <>{props.children}</>;
}
